import { z } from "zod";
import stringSchema from "@/lib/utils/stringSchema";


const formSchema = z.object({
  account_id: stringSchema({ key: "Account", required: true }),
  renewed: z.boolean(),
  internal_approval: z.boolean(),
  internal_approval_person: z.string().optional().nullable(),
  external_approval: z.boolean(),
  external_approval_person: z.string().optional().nullable(),
  function_ids: z.array(z.string()).optional().nullable(),
  department_ids: z.array(z.string()).optional().nullable(),
  country_ids: z.array(z.string()).optional().nullable(),
  region_id: z.string().optional().nullable(),
  entity_id: stringSchema({ key: "Entity", required: true }),
  nmq_entity_id: stringSchema({ key: "NMQ Entity", required: true }),
  currency: stringSchema({ key: "Currency", required: true }),
  master_sow_id: z.string().optional().nullable(),
  payment_type: stringSchema({ key: "Payment Type", required: true }),
  payment_system: stringSchema({ key: "Payment System", required: true }),
  po_number: z.string().optional().nullable(),
  details: z.string().optional().nullable(),
  short_description: z.string().optional().nullable(),
  parent_id: z.string().optional().nullable(),
  periods: z.array(
    z.object({
      service_period: z.string().optional().nullable(),
      amount: z.union([z.string(), z.number()]).optional().nullable(),
      description: z.string().optional().nullable(),
      is_it_manual: z.boolean().optional().nullable(),
    })
  ).optional().nullable(),
  start_date: z.preprocess((arg) => {
    if (typeof arg === "string" || arg instanceof Date) {
      return new Date(arg);
    }
    return arg;
  }, z.date()),
  end_date: z.preprocess((arg) => {
    if (typeof arg === "string" || arg instanceof Date) {
      return new Date(arg);
    }
    return arg;
  }, z.date()),
  is_package: z.boolean().optional().nullable(),
  package_name: z.string().optional().nullable(),
}).refine((data) => data.start_date <= data.end_date, {
  message: "Start date cannot be greater than end date",
  path: ["start_date"],
}).refine((data) => !data.is_package || (data.is_package && data.package_name), {
  message: "Package name is required when is_package is true",
  path: ["package_name"],
});

export default formSchema;
